import { BaseNetworkActionValidator } from '../base.network.action.validator';
import { ProtectedEntity } from '@nirvana/shared/dtos/types/protected-entities/common';
import { ProtectedEntitiesHelper } from '../../../helpers/protectedEntities/protected.entities.helper';

export class RiskScanActionValidator extends BaseNetworkActionValidator {
  protected canRunForUnmanagedCompanies = false;
  protected requiresTasksEnabled = true;

  protected _canPerformAction(record: ProtectedEntity): boolean {
    if (!ProtectedEntitiesHelper.isComputer(record)) {
      return true;
    }

    if (record.specifics.appId === Constants.Endpoints.APP_IDS.APPID_NSVA) {
      return false;
    }

    if (record.specifics.hasVulnerabilityAssessment) {
      return true;
    }

    return false;
  }
}
